import { lazy, Suspense } from "react";
import { Helmet } from "react-helmet";
import useUserData from "../../Hooks/useUserData";

const FootballLoading = lazy(() => import("../../Utils/FootballLoading"));
const MatuFeed = lazy(() => import("../Feed/MatuFeed"));

const Home = () => {
  const { userData, loading, error } = useUserData();

  if (loading) {
    return (
      <Suspense fallback={null}>
        <FootballLoading />
      </Suspense>
    );
  }

  if (error && error !== "No se encontraron datos para este usuario.") {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#F2F6F4] px-4">
        <div className="w-full max-w-md rounded-2xl border border-[#D8E2DC] bg-white p-6">
          <p className="mb-2 text-lg font-bold text-[#0A1410]">No se pudieron cargar los datos</p>
          <p className="mb-4 text-sm text-[#5A6B62]">{error}</p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="w-full rounded-xl bg-[#0D5C47] px-4 py-2 font-semibold text-white"
          >
            Reintentar
          </button>
        </div>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>DeportivosPro | Consejos y análisis deportivos</title>
        <meta name="description" content="Consejos y análisis deportivos informativos." />
        <meta name="theme-color" content="#0D5C47" />
      </Helmet>
      <Suspense fallback={null}>
        <MatuFeed userData={userData} />
      </Suspense>
    </>
  );
};

export default Home;
